import { render, staticRenderFns } from "./OrdersTableInfo.vue?vue&type=template&id=255fc7f6&"
import script from "./OrdersTableInfo.vue?vue&type=script&lang=js&"
export * from "./OrdersTableInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports